import { render, staticRenderFns } from "./checkbox-group.vue?vue&type=template&id=7289a290&"
import script from "./checkbox-group.vue?vue&type=script&lang=js&"
export * from "./checkbox-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7289a290')) {
      api.createRecord('7289a290', component.options)
    } else {
      api.reload('7289a290', component.options)
    }
    module.hot.accept("./checkbox-group.vue?vue&type=template&id=7289a290&", function () {
      api.rerender('7289a290', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/checkbox/src/checkbox-group.vue"
export default component.exports